import { Component } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

import { Button, Result, notification } from 'antd';
import { WPLE_API } from '../api/request';

class WpleOrderStatus extends Component {
  constructor() {
    super(...arguments);

    this.state = {
      buttonText: 'Check Order Status',
      buttonLoading: false,
    };
  }

  checkOrderStatus = () => {
    this.setState({ buttonLoading: true });

    WPLE_API('orderstatus', { orderid: this.props.orderid }).then((res) => {
      ///if (res.success) {
      if (res.success != 'Active') {
        notification.open({
          message: 'Verification Pending!',
          description:
            'Please complete the email verification in order to finish the order.',
          duration: 20,
        });
      } else {
        this.setState({ buttonText: 'Complete' });
        //verification complete
        this.props.nextStep(3);
      }
      // } else {
      //   notification.open({
      //     message: 'Error!',
      //     description: res.error.msg,
      //     duration: 20,
      //   });
      // }

      this.setState({ buttonLoading: false });
    });
  };

  resendApproverEmail = () => {
    this.setState({ buttonLoading: true });

    WPLE_API('resendverificationemail', { orderid: this.props.orderid }).then(
      (res) => {
        ///if (res.success) {
        notification.open({
          message: 'Success',
          description: 'Verification email have been resent!',
          duration: 10,
        });
        // } else {
        //   notification.open({
        //     message: 'Error!',
        //     description: res.error.msg,
        //     duration: 20,
        //   });
        // }

        this.setState({ buttonLoading: false });
      }
    );
  };

  render() {
    const { buttonText, buttonLoading } = this.state;
    let stitle = `To complete the order, Please check inbox of verification email address [${this.props.approver}] you chose in the last step. You must click on the verification link and enter the code provided in email.`;

    return (
      <Result
        status="info"
        title="Final Step: Awaiting Email Verification"
        subTitle={stitle}
        extra={[
          <Button
            type="primary"
            key="status"
            onClick={this.checkOrderStatus}
            loading={buttonLoading}>
            {buttonText}
          </Button>,
          <Button
            key="resend"
            onClick={this.resendApproverEmail}
            loading={buttonLoading}>
            Resend Verification Email
          </Button>,
        ]}
      />
    );
  }
}

export default WpleOrderStatus;

